import { render, staticRenderFns } from "./fictionDetail.vue?vue&type=template&id=29294964"
import script from "./fictionDetail.vue?vue&type=script&lang=js"
export * from "./fictionDetail.vue?vue&type=script&lang=js"
import style0 from "./fictionDetail.vue?vue&type=style&index=0&id=29294964&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports